import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { createSelector } from 'reselect';
import { getAllBillings, getBrandList, getClientList, getMarketList } from '../../../../slices/auth/settings/thunk';
import { getBillingSuccess, getBrandSuccess, setBrandId, setClientId } from '../../../../slices/auth/settings/reducer';
import 'datatables.net-buttons-bs5';
import 'datatables.net-responsive-bs5';
import { setBrandModalData, setBrandModalType, toggleBrandActivateModal, toggleBrandDeleteModal, toggleBrandModal } from '../../../../slices/modals/reducer';
import { setInnerPreloader } from '../../../../slices/layouts/reducer';
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");
import { replace, push } from "redux-first-history";
import { setBrandPath, setClientPath } from '../../../../slices/auth/menu/thunk';
import { toast } from 'react-toastify';
import { setBreadcrumb } from '../../../../slices/auth/menu/reducer';

/**
 * @component
 * Represents the BrandTable component, which displays and manages information, including adding, deleting, and editing clients.
 */
function BrandTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { pathname } = location;

  const selectedStates = createSelector(state => state, state => ({
    permission: state.Permission.permission,
    brandData: state.Settings.brands,
    title: state.MenuData.title
  }))
  const { permission, brandData, title } = useSelector(selectedStates);
  // Brand Data
  const [brand, setBrand] = useState([]);

  useEffect(() => {
    if (brandData) {
      setBrand(brandData);
    }
  }, [brandData]);

  // Table
  /* eslint-disable no-unused-vars */
  const tableRef = useRef();
  useEffect(() => {
    if (brand) {
      try {
        const table = $(tableRef.current).DataTable({
          data: brand,
          columns: [
            // {
            //   data: null,
            //   title: `<input type="checkbox" class="form-check-input" />`,
            //   orderable: false,
            //   render: () => {
            //     return `<input type="checkbox" class="form-check-input" />`
            //   }
            // },
            {
              data: "name",
              title: "Brand Name",
              render: (data, type, row) => {
                return `<a class="brand link-danger text-decoration-underline" role="button" data-id="${row.id}">${data}</a>`
              }
            },
            {
              data: null,
              title: "Markets",
              render: (data, type, row) => {
                return ``
              }
            },
            {
              data: null,
              title: "Status",
              render: (data, type, row) => {
                if (row.hasOwnProperty('status')) {
                  switch ((row.status)) {
                    case true:
                      return `<span class="badge bg-success-subtle text-primary fs-11 text-uppercase">
                                                  <i class="ri-checkbox-circle-line align-bottom"></i> Active
                                              </span>`;

                    case false:
                      return `<span class="badge bg-danger-subtle text-primary fs-11 text-uppercase">
                                                  <i class="ri-close-circle-line align-bottom"></i> Inactive
                                              </span>`;

                  }
                }
                return '';
              }
            },
            {
              data: null,
              title: "Action",
              render: (data, type, row) => {
                let editBtnStr = ``;
                let toggleBrandBtnStr = ``;
                if (permission.brands[row._id]) {
                  if (permission.brands[row._id].permissionsWK.includes("companyDetailsEdit")) {
                    editBtnStr = `<div class='edit d-inline-block align-items-center'>
                                    <button class='btn btn-sm edit-item-btn text-muted fs-14'>
                                        <i class='ri-pencil-fill align-bottom'></i>
                                    </button>
                                </div>`;
                  }
                  if (permission.brands[row._id].permissionsWK.includes("companyDetailsDelete")) {
                    if (row.status === true) {
                      toggleBrandBtnStr = ` <div class='remove d-inline-block align-items-center'>
                                        <button class='btn btn-sm remove-item-btn text-muted fs-14'>
                                            <i class="ri-delete-bin-fill align-bottom"></i>
                                        </button>
                                    </div>`
                    } else {
                      toggleBrandBtnStr = ` <div class='remove d-inline-block align-items-center'>
                                        <button class='btn btn-sm remove-item-btn text-muted fs-14'>
                                            <i class="ri-lock-unlock-fill align-bottom"></i>
                                        </button>
                                    </div>`
                    }
                  }
                }
                return `<div>${editBtnStr}${toggleBrandBtnStr}</div>`;
              }
            }
          ],
          responsive: true,
          columnDefs: [
            { responsivePriority: 1, targets: [1, -2] },
            { responsivePriority: 2, targets: "_all" }
          ],
          language: {
            search: "<i class='ri-search-line search-icon'></i>",
            searchPlaceholder: "Search for brands..."
          },
          info: false,
          destroy: true,
        });
        /* eslint-enable no-unused-vars */

        table.on("click", ".brand", async function () {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = table.row(tr).data();
          if (data) {
            table.destroy();
            dispatch(setBrandId(data._id));
            dispatch(setBrandPath(data._id));
            dispatch(setClientPath(data.clientId));
            dispatch(setInnerPreloader(true));
            const srcPath = `${pathname}/${this.innerText.toLowerCase().replaceAll(/\s+/g, "-")}`
            dispatch(getMarketList(data._id)).then(res => {
              dispatch(push(srcPath, { markets: res.payload, brands: brand, brandId: data._id, clientId: data.clientId, title: [...title, { name: data.name, src: srcPath }] }));
              dispatch(setInnerPreloader(false));
            })
          }
        });

        table.on("click", ".edit", function () {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = table.row(tr).data();
          if (data) {
            dispatch(setBrandId(data._id));
            dispatch(setBrandModalData(data));
            dispatch(setBrandModalType("edit"));
            dispatch(getBillingSuccess(null));
            dispatch(getAllBillings());
            dispatch(toggleBrandModal());
          }
        });

        table.on("click", ".remove", function () {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = table.row(tr).data();
          if (data) {
            dispatch(setBrandId(data._id));
            if (data.status === true) {
              dispatch(toggleBrandDeleteModal());
            } else {
              dispatch(toggleBrandActivateModal());
            }
          }
        });

        return function () {
          table.destroy();
        }
      } catch (error) {
        toast.error('Something went wrong');
      }
    }
  }, [brand]);
  return (
    <div>
      <table className='align-middle table-nowrap mb-0 table' style={{ width: "100%" }} ref={tableRef}>
        <thead className='table-light'></thead>
        <tbody></tbody>
      </table>
    </div>
  )
}

export default BrandTable
